import React from 'react';
import { GoogleLoginButton } from '../GoogleLoginButton';

export default function AppHeader({ ctx }) {
  const { navigate } = ctx;

  return (
    <header style={{ background: 'rgba(255,255,255,0.82)', backdropFilter: 'blur(12px)', borderBottom: '1px solid rgba(0,0,0,0.06)', position: 'sticky', top: 0, zIndex: 100 }}>
      <div className="header-inner">
        <div className="header-row1-content">
          <button
            onClick={() => navigate('/')}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <span className="serif" style={{ fontSize: 32, fontWeight: 700, background: 'linear-gradient(135deg, #9333ea, #ec4899)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>HowToon</span>
          </button>

          <div className="header-right">
            <GoogleLoginButton />
          </div>
        </div>
      </div>
    </header>
  );
}
